// Generated by purs version 0.14.5
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var CostEstimation_Calculations = require("../CostEstimation.Calculations/index.js");
var CostEstimation_Styles = require("../CostEstimation.Styles/index.js");
var CostEstimationTableWrapper = require("../CostEstimationTableWrapper/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Number = require("../Data.Number/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Variant_Internal = require("../Data.Variant.Internal/index.js");
var Effect = require("../Effect/index.js");
var Gap = require("../Gap/index.js");
var Kishimen = require("../Kishimen/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var SocialExpenseIndicator = require("../SocialExpenseIndicator/index.js");
var TacoButton = require("../TacoButton/index.js");
var TacoButton_Types = require("../TacoButton.Types/index.js");
var TacoCheckbox = require("../TacoCheckbox/index.js");
var TacoConstants = require("../TacoConstants/index.js");
var TacoIcon_Icons_Types = require("../TacoIcon.Icons.Types/index.js");
var TacoModal = require("../TacoModal/index.js");
var TacoTable = require("../TacoTable/index.js");
var TacoTable_Types = require("../TacoTable.Types/index.js");
var TofuHooks = require("../TofuHooks/index.js");
var TofuJSON = require("../TofuJSON/index.js");
var Types_Component = require("../Types.Component/index.js");
var Types_Newtypes = require("../Types.Newtypes/index.js");
var Types_Unit = require("../Types.Unit/index.js");
var Utils = require("../Utils/index.js");
var ByPLPriceListId = (function () {
    function ByPLPriceListId() {

    };
    ByPLPriceListId.value = new ByPLPriceListId();
    return ByPLPriceListId;
})();
var ByPLCostClassCode = (function () {
    function ByPLCostClassCode() {

    };
    ByPLCostClassCode.value = new ByPLCostClassCode();
    return ByPLCostClassCode;
})();
var ByPLResourceClassificationGroup = (function () {
    function ByPLResourceClassificationGroup() {

    };
    ByPLResourceClassificationGroup.value = new ByPLResourceClassificationGroup();
    return ByPLResourceClassificationGroup;
})();
var ByPLSortingNumber = (function () {
    function ByPLSortingNumber() {

    };
    ByPLSortingNumber.value = new ByPLSortingNumber();
    return ByPLSortingNumber;
})();
var ByPLName = (function () {
    function ByPLName() {

    };
    ByPLName.value = new ByPLName();
    return ByPLName;
})();
var ByPLUnit = (function () {
    function ByPLUnit() {

    };
    ByPLUnit.value = new ByPLUnit();
    return ByPLUnit;
})();
var ByPLPrice = (function () {
    function ByPLPrice() {

    };
    ByPLPrice.value = new ByPLPrice();
    return ByPLPrice;
})();
var ByPLDiscountPercentage = (function () {
    function ByPLDiscountPercentage() {

    };
    ByPLDiscountPercentage.value = new ByPLDiscountPercentage();
    return ByPLDiscountPercentage;
})();
var ByPLPriceWithDiscount = (function () {
    function ByPLPriceWithDiscount() {

    };
    ByPLPriceWithDiscount.value = new ByPLPriceWithDiscount();
    return ByPLPriceWithDiscount;
})();
var ByPLCurrencyId = (function () {
    function ByPLCurrencyId() {

    };
    ByPLCurrencyId.value = new ByPLCurrencyId();
    return ByPLCurrencyId;
})();
var ByPLDiscountGroupCode = (function () {
    function ByPLDiscountGroupCode() {

    };
    ByPLDiscountGroupCode.value = new ByPLDiscountGroupCode();
    return ByPLDiscountGroupCode;
})();
var ByPLInternalCode = (function () {
    function ByPLInternalCode() {

    };
    ByPLInternalCode.value = new ByPLInternalCode();
    return ByPLInternalCode;
})();
var ByPLOwnCode = (function () {
    function ByPLOwnCode() {

    };
    ByPLOwnCode.value = new ByPLOwnCode();
    return ByPLOwnCode;
})();
var ByPLContract = (function () {
    function ByPLContract() {

    };
    ByPLContract.value = new ByPLContract();
    return ByPLContract;
})();
var ByPLUser = (function () {
    function ByPLUser() {

    };
    ByPLUser.value = new ByPLUser();
    return ByPLUser;
})();
var ByPLEanCode = (function () {
    function ByPLEanCode() {

    };
    ByPLEanCode.value = new ByPLEanCode();
    return ByPLEanCode;
})();
var ByPLTaxRate = (function () {
    function ByPLTaxRate() {

    };
    ByPLTaxRate.value = new ByPLTaxRate();
    return ByPLTaxRate;
})();
var ByPLIndex = (function () {
    function ByPLIndex() {

    };
    ByPLIndex.value = new ByPLIndex();
    return ByPLIndex;
})();
var ByPLVendor = (function () {
    function ByPLVendor() {

    };
    ByPLVendor.value = new ByPLVendor();
    return ByPLVendor;
})();
var ByPLVendorCode = (function () {
    function ByPLVendorCode() {

    };
    ByPLVendorCode.value = new ByPLVendorCode();
    return ByPLVendorCode;
})();
var ByPLVendorUnit = (function () {
    function ByPLVendorUnit() {

    };
    ByPLVendorUnit.value = new ByPLVendorUnit();
    return ByPLVendorUnit;
})();
var ByPLVendorBatchSize = (function () {
    function ByPLVendorBatchSize() {

    };
    ByPLVendorBatchSize.value = new ByPLVendorBatchSize();
    return ByPLVendorBatchSize;
})();
var ColPLCheckbox = (function () {
    function ColPLCheckbox() {

    };
    ColPLCheckbox.value = new ColPLCheckbox();
    return ColPLCheckbox;
})();
var ColPLPriceListId = (function () {
    function ColPLPriceListId() {

    };
    ColPLPriceListId.value = new ColPLPriceListId();
    return ColPLPriceListId;
})();
var ColPLCostClassCode = (function () {
    function ColPLCostClassCode() {

    };
    ColPLCostClassCode.value = new ColPLCostClassCode();
    return ColPLCostClassCode;
})();
var ColPLResourceClassificationGroup = (function () {
    function ColPLResourceClassificationGroup() {

    };
    ColPLResourceClassificationGroup.value = new ColPLResourceClassificationGroup();
    return ColPLResourceClassificationGroup;
})();
var ColPLSortingNumber = (function () {
    function ColPLSortingNumber() {

    };
    ColPLSortingNumber.value = new ColPLSortingNumber();
    return ColPLSortingNumber;
})();
var ColPLName = (function () {
    function ColPLName() {

    };
    ColPLName.value = new ColPLName();
    return ColPLName;
})();
var ColPLUnit = (function () {
    function ColPLUnit() {

    };
    ColPLUnit.value = new ColPLUnit();
    return ColPLUnit;
})();
var ColPLPrice = (function () {
    function ColPLPrice() {

    };
    ColPLPrice.value = new ColPLPrice();
    return ColPLPrice;
})();
var ColPLDiscountPercentage = (function () {
    function ColPLDiscountPercentage() {

    };
    ColPLDiscountPercentage.value = new ColPLDiscountPercentage();
    return ColPLDiscountPercentage;
})();
var ColPLPriceWithDiscount = (function () {
    function ColPLPriceWithDiscount() {

    };
    ColPLPriceWithDiscount.value = new ColPLPriceWithDiscount();
    return ColPLPriceWithDiscount;
})();
var ColPLCurrencyId = (function () {
    function ColPLCurrencyId() {

    };
    ColPLCurrencyId.value = new ColPLCurrencyId();
    return ColPLCurrencyId;
})();
var ColPLDiscountGroupCode = (function () {
    function ColPLDiscountGroupCode() {

    };
    ColPLDiscountGroupCode.value = new ColPLDiscountGroupCode();
    return ColPLDiscountGroupCode;
})();
var ColPLInternalCode = (function () {
    function ColPLInternalCode() {

    };
    ColPLInternalCode.value = new ColPLInternalCode();
    return ColPLInternalCode;
})();
var ColPLOwnCode = (function () {
    function ColPLOwnCode() {

    };
    ColPLOwnCode.value = new ColPLOwnCode();
    return ColPLOwnCode;
})();
var ColPLContract = (function () {
    function ColPLContract() {

    };
    ColPLContract.value = new ColPLContract();
    return ColPLContract;
})();
var ColPLValidDate = (function () {
    function ColPLValidDate() {

    };
    ColPLValidDate.value = new ColPLValidDate();
    return ColPLValidDate;
})();
var ColPLChangeDate = (function () {
    function ColPLChangeDate() {

    };
    ColPLChangeDate.value = new ColPLChangeDate();
    return ColPLChangeDate;
})();
var ColPLUser = (function () {
    function ColPLUser() {

    };
    ColPLUser.value = new ColPLUser();
    return ColPLUser;
})();
var ColPLEanCode = (function () {
    function ColPLEanCode() {

    };
    ColPLEanCode.value = new ColPLEanCode();
    return ColPLEanCode;
})();
var ColPLTaxRate = (function () {
    function ColPLTaxRate() {

    };
    ColPLTaxRate.value = new ColPLTaxRate();
    return ColPLTaxRate;
})();
var ColPLIndex = (function () {
    function ColPLIndex() {

    };
    ColPLIndex.value = new ColPLIndex();
    return ColPLIndex;
})();
var ColPLVendor = (function () {
    function ColPLVendor() {

    };
    ColPLVendor.value = new ColPLVendor();
    return ColPLVendor;
})();
var ColPLVendorCode = (function () {
    function ColPLVendorCode() {

    };
    ColPLVendorCode.value = new ColPLVendorCode();
    return ColPLVendorCode;
})();
var ColPLVendorUnit = (function () {
    function ColPLVendorUnit() {

    };
    ColPLVendorUnit.value = new ColPLVendorUnit();
    return ColPLVendorUnit;
})();
var ColPLVendorBatchSize = (function () {
    function ColPLVendorBatchSize() {

    };
    ColPLVendorBatchSize.value = new ColPLVendorBatchSize();
    return ColPLVendorBatchSize;
})();
var styleSet = CostEstimation_Styles.costEstimationTableStyleSet(TacoConstants.resourcePriceListColors);
var replaceSelectedWithCheckedResourcesBtn = function (onReplaceResources) {
    return TacoButton.component()()({
        text: "Korvaa valittu panos",
        buttonStyle: TacoButton_Types.Filled.value,
        size: TacoConstants.L.value,
        icon: new Data_Maybe.Just(TacoIcon_Icons_Types.IconCopyToProjectV1.value),
        onClick: new Data_Maybe.Just(onReplaceResources)
    });
};
var replaceSelectedResourceFromPricelistBtn = function (action) {
    return TacoButton.component()()({
        text: "Vaihda panos",
        buttonStyle: TacoButton_Types.Filled.value,
        size: TacoConstants.L.value,
        icon: new Data_Maybe.Just(TacoIcon_Icons_Types.IconArrowLeft.value),
        color: TacoConstants.resourcePriceListColors.border,
        onClick: new Data_Maybe.Just(action)
    });
};
var priceWithoutDiscountValue = function (r) {
    var socExpPercentage = CostEstimation_Calculations.lookupSocialExpensePercentage(r.socialExpensePercentagesByCostClass)(r.res.costClassCode);
    var price = Utils.defaultNull(0.0)(r.res.price);
    if (r.showSocialExpensesInCosts) {
        return price * (1.0 + socExpPercentage);
    };
    return price;
};
var priceWithDiscountValue = function (r) {
    var socExpPercentage = CostEstimation_Calculations.lookupSocialExpensePercentage(r.socialExpensePercentagesByCostClass)(r.res.costClassCode);
    if (r.showSocialExpensesInCosts) {
        return r.res.priceWithDiscount * (1.0 + socExpPercentage);
    };
    return r.res.priceWithDiscount;
};
var getResourcePriceById = function (xs) {
    return function (id) {
        return Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
            return v.res;
        })(Data_Array.find((function () {
            var $394 = Data_Eq.eq(Data_Eq.eqInt)(id);
            return function ($395) {
                return $394((function (v) {
                    return v.res.orgResourcePriceId;
                })($395));
            };
        })())(xs));
    };
};
var getPLSortingValue = function (property) {
    return function (r) {
        var bySortingNumber = TacoTable_Types.NumberValue.create(Utils.defaultNull(0.0)(Utils.bindMaybeNullable(Data_Number.fromString)(r.res.sortingNumber)));
        if (property instanceof ByPLPriceListId) {
            return new TacoTable_Types.StringValue(Data_Newtype.unwrap()(r.res.priceListId));
        };
        if (property instanceof ByPLCostClassCode) {
            return TacoTable_Types.StringValue.create(Utils.foldNullable("")(Data_Newtype.unwrap())(r.res.costClassCode));
        };
        if (property instanceof ByPLResourceClassificationGroup) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.resourceClassificationGroup));
        };
        if (property instanceof ByPLSortingNumber) {
            return bySortingNumber;
        };
        if (property instanceof ByPLName) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.name));
        };
        if (property instanceof ByPLUnit) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.unit));
        };
        if (property instanceof ByPLPrice) {
            return TacoTable_Types.NumberValue.create(priceWithoutDiscountValue(r));
        };
        if (property instanceof ByPLDiscountPercentage) {
            return new TacoTable_Types.NumberValue(r.res.discountPercentage);
        };
        if (property instanceof ByPLPriceWithDiscount) {
            return TacoTable_Types.NumberValue.create(priceWithDiscountValue(r));
        };
        if (property instanceof ByPLCurrencyId) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.currencyId));
        };
        if (property instanceof ByPLDiscountGroupCode) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.discountGroupCode));
        };
        if (property instanceof ByPLInternalCode) {
            return new TacoTable_Types.IntValue(r.res.orgResourcePriceId);
        };
        if (property instanceof ByPLOwnCode) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.ownCode));
        };
        if (property instanceof ByPLContract) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.contract));
        };
        if (property instanceof ByPLUser) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.user));
        };
        if (property instanceof ByPLEanCode) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.eanCode));
        };
        if (property instanceof ByPLTaxRate) {
            return TacoTable_Types.NumberValue.create(Utils.defaultNull(0.0)(r.res.taxRate));
        };
        if (property instanceof ByPLIndex) {
            return TacoTable_Types.NumberValue.create(Utils.defaultNull(0.0)(r.res.index));
        };
        if (property instanceof ByPLVendor) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.vendor));
        };
        if (property instanceof ByPLVendorCode) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.vendorCode));
        };
        if (property instanceof ByPLVendorUnit) {
            return TacoTable_Types.StringValue.create(Utils.defaultNull("")(r.res.vendorUnit));
        };
        if (property instanceof ByPLVendorBatchSize) {
            return TacoTable_Types.NumberValue.create(Utils.defaultNull(0.0)(r.res.vendorBatchSize));
        };
        throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 284, column 32 - line 306, column 85): " + [ property.constructor.name ]);
    };
};
var getPLRowDataFromOrgResourcePriceId = function (xs) {
    return function (id) {
        return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.find((function () {
            var $396 = Data_Eq.eq(Data_Eq.eqInt)(id);
            return function ($397) {
                return $396((function (v) {
                    return v.res.orgResourcePriceId;
                })($397));
            };
        })())(xs))(function (row) {
            return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(row);
        });
    };
};
var getPLColumnLabelText = function (col) {
    if (col instanceof ColPLCheckbox) {
        return "Valinta";
    };
    if (col instanceof ColPLPriceListId) {
        return "Hinnasto";
    };
    if (col instanceof ColPLCostClassCode) {
        return "PL";
    };
    if (col instanceof ColPLResourceClassificationGroup) {
        return "PRyhm\xe4";
    };
    if (col instanceof ColPLSortingNumber) {
        return "J\xe4rjestys";
    };
    if (col instanceof ColPLName) {
        return "Nimi";
    };
    if (col instanceof ColPLUnit) {
        return "Yks";
    };
    if (col instanceof ColPLPrice) {
        return "Alentamaton Hinta";
    };
    if (col instanceof ColPLDiscountPercentage) {
        return "Ale-%";
    };
    if (col instanceof ColPLPriceWithDiscount) {
        return "Hinta sis. ale";
    };
    if (col instanceof ColPLCurrencyId) {
        return "Val";
    };
    if (col instanceof ColPLDiscountGroupCode) {
        return "AleRyhm\xe4";
    };
    if (col instanceof ColPLInternalCode) {
        return "Sis. Tunnus";
    };
    if (col instanceof ColPLOwnCode) {
        return "Oma Tunnus";
    };
    if (col instanceof ColPLContract) {
        return "Sopimus";
    };
    if (col instanceof ColPLValidDate) {
        return "Voimassa";
    };
    if (col instanceof ColPLChangeDate) {
        return "Muutosp\xe4iv\xe4";
    };
    if (col instanceof ColPLUser) {
        return "K\xe4sittelij\xe4";
    };
    if (col instanceof ColPLEanCode) {
        return "EAN-koodi";
    };
    if (col instanceof ColPLTaxRate) {
        return "Alv-%";
    };
    if (col instanceof ColPLIndex) {
        return "Indeksi";
    };
    if (col instanceof ColPLVendor) {
        return "Toimittaja";
    };
    if (col instanceof ColPLVendorCode) {
        return "Toimittajan oma";
    };
    if (col instanceof ColPLVendorUnit) {
        return "Myyntier\xe4n yksikk\xf6";
    };
    if (col instanceof ColPLVendorBatchSize) {
        return "Myyntier\xe4n nettosis\xe4lt\xf6";
    };
    throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 344, column 28 - line 369, column 52): " + [ col.constructor.name ]);
};
var mkPlColumn = function (props) {
    return function (col) {
        var mkSocialExpenseLabel = function (text) {
            return Gap.gapX(TacoConstants.XS.value)([ Data_Monoid.guard(React_Basic.monoidJSX)(props.showSocialExpensesInCosts)(SocialExpenseIndicator.socialExpenseIndicator), React_Basic_DOM.text(text) ]);
        };
        if (col instanceof ColPLCheckbox) {
            return {
                key: "checkbox",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("2rem"),
                cell: TacoTable_Types.JSXCell.create([ TacoTable_Types.Input.value ])(function (r) {
                    return TacoCheckbox.component()()({
                        isChecked: r.checked,
                        onToggle: new TacoCheckbox.NoEvent((function () {
                            if (r.checked) {
                                return props.setCheckedResources(function (s) {
                                    return Data_Set["delete"](Data_Ord.ordInt)(r.res.orgResourcePriceId)(s);
                                });
                            };
                            return props.setCheckedResources(function (s) {
                                return Data_Set.insert(Data_Ord.ordInt)(r.res.orgResourcePriceId)(s);
                            });
                        })())
                    });
                }),
                sortProperty: Data_Maybe.Nothing.value,
                headerJSX: new Data_Maybe.Just((function () {
                    var hasChecked = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Set.isEmpty)(props.checkedResources);
                    return TacoCheckbox.component()()({
                        isChecked: hasChecked,
                        onToggle: new TacoCheckbox.NoEvent((function () {
                            if (hasChecked) {
                                return props.setCheckedResources(function (v) {
                                    return Data_Set.empty;
                                });
                            };
                            return props.setCheckedResources(function (v) {
                                return Data_Set.fromFoldable(Data_Foldable.foldableArray)(Data_Ord.ordInt)(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                                    return v1.res.orgResourcePriceId;
                                })(props.priceListRows));
                            });
                        })()),
                        testId: "toggle-all-resources-button"
                    });
                })())
            };
        };
        if (col instanceof ColPLPriceListId) {
            return {
                key: "priceListId",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("15rem"),
                cell: new TacoTable_Types.PlainTextCell((function () {
                    var $398 = Data_Newtype.unwrap();
                    return function ($399) {
                        return $398((function (v) {
                            return v.res.priceListId;
                        })($399));
                    };
                })()),
                sortProperty: new Data_Maybe.Just(ByPLPriceListId.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLCostClassCode) {
            return {
                key: "costClassCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("5rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.foldNullable("")(Data_Newtype.unwrap())(r.res.costClassCode);
                }),
                sortProperty: new Data_Maybe.Just(ByPLCostClassCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLResourceClassificationGroup) {
            return {
                key: "resourceClassificationGroup",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("5rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.resourceClassificationGroup);
                }),
                sortProperty: new Data_Maybe.Just(ByPLResourceClassificationGroup.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLSortingNumber) {
            return {
                key: "sortingNumber",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.sortingNumber);
                }),
                sortProperty: new Data_Maybe.Just(ByPLSortingNumber.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLName) {
            return {
                key: "name",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.FlexMinWidth(4, "16rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.name);
                }),
                sortProperty: new Data_Maybe.Just(ByPLName.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLUnit) {
            return {
                key: "unit",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("4rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.unit);
                }),
                sortProperty: new Data_Maybe.Just(ByPLUnit.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLPrice) {
            return {
                key: "price",
                label: mkSocialExpenseLabel(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("10rem"),
                cell: new TacoTable_Types.PlainCurrencyCell(props.projectCurrency, priceWithoutDiscountValue),
                sortProperty: new Data_Maybe.Just(ByPLPrice.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLDiscountPercentage) {
            return {
                key: "discountPercentage",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("4rem"),
                cell: new TacoTable_Types.PlainNumberCell(2, function (v) {
                    return v.res.discountPercentage;
                }),
                sortProperty: new Data_Maybe.Just(ByPLDiscountPercentage.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLPriceWithDiscount) {
            return {
                key: "priceWithDiscount",
                label: mkSocialExpenseLabel(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("8rem"),
                cell: new TacoTable_Types.PlainCurrencyCell(props.projectCurrency, priceWithDiscountValue),
                sortProperty: new Data_Maybe.Just(ByPLPriceWithDiscount.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLCurrencyId) {
            return {
                key: "currencyId",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("4rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.currencyId);
                }),
                sortProperty: new Data_Maybe.Just(ByPLCurrencyId.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLDiscountGroupCode) {
            return {
                key: "discountGroupCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.discountGroupCode);
                }),
                sortProperty: new Data_Maybe.Just(ByPLDiscountGroupCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLInternalCode) {
            return {
                key: "internalCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("4rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Data_Show.show(Data_Show.showInt)(r.res.orgResourcePriceId);
                }),
                sortProperty: new Data_Maybe.Just(ByPLInternalCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLOwnCode) {
            return {
                key: "ownCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.ownCode);
                }),
                sortProperty: new Data_Maybe.Just(ByPLOwnCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLContract) {
            return {
                key: "contract",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.contract);
                }),
                sortProperty: new Data_Maybe.Just(ByPLContract.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLValidDate) {
            return {
                key: "validDate",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("7rem"),
                cell: new TacoTable_Types.PlainDateStringCell(function (r) {
                    return Utils.defaultNull("")(r.res.validDate);
                }),
                sortProperty: Data_Maybe.Nothing.value,
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLChangeDate) {
            return {
                key: "changeDate",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("7rem"),
                cell: new TacoTable_Types.PlainDateStringCell(function (r) {
                    return Utils.defaultNull("")(r.res.changeDate);
                }),
                sortProperty: Data_Maybe.Nothing.value,
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLUser) {
            return {
                key: "user",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.user);
                }),
                sortProperty: new Data_Maybe.Just(ByPLUser.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLEanCode) {
            return {
                key: "eanCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.eanCode);
                }),
                sortProperty: new Data_Maybe.Just(ByPLEanCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLTaxRate) {
            return {
                key: "taxRate",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("4rem"),
                cell: new TacoTable_Types.PlainNumberCell(2, function (r) {
                    return Utils.defaultNull(0.0)(r.res.taxRate);
                }),
                sortProperty: new Data_Maybe.Just(ByPLTaxRate.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLIndex) {
            return {
                key: "index",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("5rem"),
                cell: new TacoTable_Types.PlainNumberCell(2, function (r) {
                    return Utils.defaultNull(0.0)(r.res.index);
                }),
                sortProperty: new Data_Maybe.Just(ByPLIndex.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLVendor) {
            return {
                key: "vendor",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("6rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.vendor);
                }),
                sortProperty: new Data_Maybe.Just(ByPLVendor.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLVendorCode) {
            return {
                key: "vendorCode",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("10rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.vendorCode);
                }),
                sortProperty: new Data_Maybe.Just(ByPLVendorCode.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLVendorUnit) {
            return {
                key: "vendorUnit",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("10rem"),
                cell: new TacoTable_Types.PlainTextCell(function (r) {
                    return Utils.defaultNull("")(r.res.vendorUnit);
                }),
                sortProperty: new Data_Maybe.Just(ByPLVendorUnit.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        if (col instanceof ColPLVendorBatchSize) {
            return {
                key: "vendorBatchSize",
                label: React_Basic_DOM.text(getPLColumnLabelText(col)),
                width: new TacoTable_Types.Fixed("12cm"),
                cell: new TacoTable_Types.PlainNumberCell(2, function (r) {
                    return Utils.defaultNull(0.0)(r.res.vendorBatchSize);
                }),
                sortProperty: new Data_Maybe.Just(ByPLVendorBatchSize.value),
                headerJSX: Data_Maybe.Nothing.value
            };
        };
        throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 401, column 24 - line 614, column 8): " + [ col.constructor.name ]);
    };
};
var getNamePLSortProperty = {
    getName: function (v) {
        return "PLSortProperty";
    }
};
var genericPLColumn = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ColPLCheckbox.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ColPLPriceListId.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return ColPLCostClassCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ColPLResourceClassificationGroup.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return ColPLSortingNumber.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return ColPLName.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return ColPLUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return ColPLPrice.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return ColPLDiscountPercentage.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return ColPLPriceWithDiscount.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return ColPLCurrencyId.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return ColPLDiscountGroupCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return ColPLInternalCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
            return ColPLOwnCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
            return ColPLContract.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
            return ColPLValidDate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
            return ColPLChangeDate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
            return ColPLUser.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))) {
            return ColPLEanCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))) {
            return ColPLTaxRate.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))) {
            return ColPLIndex.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))) {
            return ColPLVendor.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))))) {
            return ColPLVendorCode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))))) {
            return ColPLVendorUnit.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))))))))) {
            return ColPLVendorBatchSize.value;
        };
        throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 338, column 1 - line 338, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ColPLCheckbox) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ColPLPriceListId) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ColPLCostClassCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ColPLResourceClassificationGroup) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof ColPLSortingNumber) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof ColPLName) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof ColPLUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof ColPLPrice) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof ColPLDiscountPercentage) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof ColPLPriceWithDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof ColPLCurrencyId) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof ColPLDiscountGroupCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof ColPLInternalCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        if (x instanceof ColPLOwnCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))));
        };
        if (x instanceof ColPLContract) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))));
        };
        if (x instanceof ColPLValidDate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))));
        };
        if (x instanceof ColPLChangeDate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))));
        };
        if (x instanceof ColPLUser) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))));
        };
        if (x instanceof ColPLEanCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))));
        };
        if (x instanceof ColPLTaxRate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))));
        };
        if (x instanceof ColPLIndex) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))));
        };
        if (x instanceof ColPLVendor) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))));
        };
        if (x instanceof ColPLVendorCode) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))))));
        };
        if (x instanceof ColPLVendorUnit) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))))));
        };
        if (x instanceof ColPLVendorBatchSize) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))))))))))))))))))))));
        };
        throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 338, column 1 - line 338, column 54): " + [ x.constructor.name ]);
    }
};
var tofuJSONPLColumn = {
    writeImpl: (function () {
        var $400 = TofuJSON.writeImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil))))))))))))))))))))))))))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant)))))))))))))))))))))))))));
        var $401 = Kishimen.genericSumToVariant(genericPLColumn)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })));
        return function ($402) {
            return $400($401($402));
        };
    })(),
    readImpl: (function () {
        var $403 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Kishimen.variantToGenericSum(genericPLColumn)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLName";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        }))({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        }))));
        var $404 = TofuJSON.readImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil))))))))))))))))))))))))))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLChangeDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCheckbox";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLContract";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCostClassCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLCurrencyId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLDiscountGroupCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLDiscountPercentage";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLEanCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLIndex";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLInternalCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLName";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLOwnCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPrice";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceListId";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLPriceWithDiscount";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLResourceClassificationGroup";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLSortingNumber";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLTaxRate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLUser";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLValidDate";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendor";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorBatchSize";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorCode";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "ColPLVendorUnit";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant)))))))))))))))))))))))))));
        return function ($405) {
            return $403($404($405));
        };
    })()
};
var eqPLSortProperty = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ByPLPriceListId && y instanceof ByPLPriceListId) {
                return true;
            };
            if (x instanceof ByPLCostClassCode && y instanceof ByPLCostClassCode) {
                return true;
            };
            if (x instanceof ByPLResourceClassificationGroup && y instanceof ByPLResourceClassificationGroup) {
                return true;
            };
            if (x instanceof ByPLSortingNumber && y instanceof ByPLSortingNumber) {
                return true;
            };
            if (x instanceof ByPLName && y instanceof ByPLName) {
                return true;
            };
            if (x instanceof ByPLUnit && y instanceof ByPLUnit) {
                return true;
            };
            if (x instanceof ByPLPrice && y instanceof ByPLPrice) {
                return true;
            };
            if (x instanceof ByPLDiscountPercentage && y instanceof ByPLDiscountPercentage) {
                return true;
            };
            if (x instanceof ByPLPriceWithDiscount && y instanceof ByPLPriceWithDiscount) {
                return true;
            };
            if (x instanceof ByPLCurrencyId && y instanceof ByPLCurrencyId) {
                return true;
            };
            if (x instanceof ByPLDiscountGroupCode && y instanceof ByPLDiscountGroupCode) {
                return true;
            };
            if (x instanceof ByPLInternalCode && y instanceof ByPLInternalCode) {
                return true;
            };
            if (x instanceof ByPLOwnCode && y instanceof ByPLOwnCode) {
                return true;
            };
            if (x instanceof ByPLContract && y instanceof ByPLContract) {
                return true;
            };
            if (x instanceof ByPLUser && y instanceof ByPLUser) {
                return true;
            };
            if (x instanceof ByPLEanCode && y instanceof ByPLEanCode) {
                return true;
            };
            if (x instanceof ByPLTaxRate && y instanceof ByPLTaxRate) {
                return true;
            };
            if (x instanceof ByPLIndex && y instanceof ByPLIndex) {
                return true;
            };
            if (x instanceof ByPLVendor && y instanceof ByPLVendor) {
                return true;
            };
            if (x instanceof ByPLVendorCode && y instanceof ByPLVendorCode) {
                return true;
            };
            if (x instanceof ByPLVendorUnit && y instanceof ByPLVendorUnit) {
                return true;
            };
            if (x instanceof ByPLVendorBatchSize && y instanceof ByPLVendorBatchSize) {
                return true;
            };
            return false;
        };
    }
};
var ordPLSortProperty = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ByPLPriceListId && y instanceof ByPLPriceListId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLPriceListId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLPriceListId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLCostClassCode && y instanceof ByPLCostClassCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLCostClassCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLCostClassCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLResourceClassificationGroup && y instanceof ByPLResourceClassificationGroup) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLResourceClassificationGroup) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLResourceClassificationGroup) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLSortingNumber && y instanceof ByPLSortingNumber) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLSortingNumber) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLSortingNumber) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLName && y instanceof ByPLName) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLName) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLName) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLUnit && y instanceof ByPLUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLPrice && y instanceof ByPLPrice) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLPrice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLPrice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLDiscountPercentage && y instanceof ByPLDiscountPercentage) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLDiscountPercentage) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLDiscountPercentage) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLPriceWithDiscount && y instanceof ByPLPriceWithDiscount) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLPriceWithDiscount) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLPriceWithDiscount) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLCurrencyId && y instanceof ByPLCurrencyId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLCurrencyId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLCurrencyId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLDiscountGroupCode && y instanceof ByPLDiscountGroupCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLDiscountGroupCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLDiscountGroupCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLInternalCode && y instanceof ByPLInternalCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLInternalCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLInternalCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLOwnCode && y instanceof ByPLOwnCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLOwnCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLOwnCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLContract && y instanceof ByPLContract) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLContract) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLContract) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLUser && y instanceof ByPLUser) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLUser) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLUser) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLEanCode && y instanceof ByPLEanCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLEanCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLEanCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLTaxRate && y instanceof ByPLTaxRate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLTaxRate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLTaxRate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLIndex && y instanceof ByPLIndex) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLIndex) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLIndex) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLVendor && y instanceof ByPLVendor) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLVendor) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLVendor) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLVendorCode && y instanceof ByPLVendorCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLVendorCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLVendorCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLVendorUnit && y instanceof ByPLVendorUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ByPLVendorUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ByPLVendorUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ByPLVendorBatchSize && y instanceof ByPLVendorBatchSize) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 279, column 1 - line 279, column 56): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPLSortProperty;
    }
};
var eqPLColumn = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ColPLCheckbox && y instanceof ColPLCheckbox) {
                return true;
            };
            if (x instanceof ColPLPriceListId && y instanceof ColPLPriceListId) {
                return true;
            };
            if (x instanceof ColPLCostClassCode && y instanceof ColPLCostClassCode) {
                return true;
            };
            if (x instanceof ColPLResourceClassificationGroup && y instanceof ColPLResourceClassificationGroup) {
                return true;
            };
            if (x instanceof ColPLSortingNumber && y instanceof ColPLSortingNumber) {
                return true;
            };
            if (x instanceof ColPLName && y instanceof ColPLName) {
                return true;
            };
            if (x instanceof ColPLUnit && y instanceof ColPLUnit) {
                return true;
            };
            if (x instanceof ColPLPrice && y instanceof ColPLPrice) {
                return true;
            };
            if (x instanceof ColPLDiscountPercentage && y instanceof ColPLDiscountPercentage) {
                return true;
            };
            if (x instanceof ColPLPriceWithDiscount && y instanceof ColPLPriceWithDiscount) {
                return true;
            };
            if (x instanceof ColPLCurrencyId && y instanceof ColPLCurrencyId) {
                return true;
            };
            if (x instanceof ColPLDiscountGroupCode && y instanceof ColPLDiscountGroupCode) {
                return true;
            };
            if (x instanceof ColPLInternalCode && y instanceof ColPLInternalCode) {
                return true;
            };
            if (x instanceof ColPLOwnCode && y instanceof ColPLOwnCode) {
                return true;
            };
            if (x instanceof ColPLContract && y instanceof ColPLContract) {
                return true;
            };
            if (x instanceof ColPLValidDate && y instanceof ColPLValidDate) {
                return true;
            };
            if (x instanceof ColPLChangeDate && y instanceof ColPLChangeDate) {
                return true;
            };
            if (x instanceof ColPLUser && y instanceof ColPLUser) {
                return true;
            };
            if (x instanceof ColPLEanCode && y instanceof ColPLEanCode) {
                return true;
            };
            if (x instanceof ColPLTaxRate && y instanceof ColPLTaxRate) {
                return true;
            };
            if (x instanceof ColPLIndex && y instanceof ColPLIndex) {
                return true;
            };
            if (x instanceof ColPLVendor && y instanceof ColPLVendor) {
                return true;
            };
            if (x instanceof ColPLVendorCode && y instanceof ColPLVendorCode) {
                return true;
            };
            if (x instanceof ColPLVendorUnit && y instanceof ColPLVendorUnit) {
                return true;
            };
            if (x instanceof ColPLVendorBatchSize && y instanceof ColPLVendorBatchSize) {
                return true;
            };
            return false;
        };
    }
};
var ordPLColumn = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ColPLCheckbox && y instanceof ColPLCheckbox) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLCheckbox) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLCheckbox) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLPriceListId && y instanceof ColPLPriceListId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLPriceListId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLPriceListId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLCostClassCode && y instanceof ColPLCostClassCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLCostClassCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLCostClassCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLResourceClassificationGroup && y instanceof ColPLResourceClassificationGroup) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLResourceClassificationGroup) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLResourceClassificationGroup) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLSortingNumber && y instanceof ColPLSortingNumber) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLSortingNumber) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLSortingNumber) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLName && y instanceof ColPLName) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLName) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLName) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLUnit && y instanceof ColPLUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLPrice && y instanceof ColPLPrice) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLPrice) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLPrice) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLDiscountPercentage && y instanceof ColPLDiscountPercentage) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLDiscountPercentage) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLDiscountPercentage) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLPriceWithDiscount && y instanceof ColPLPriceWithDiscount) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLPriceWithDiscount) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLPriceWithDiscount) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLCurrencyId && y instanceof ColPLCurrencyId) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLCurrencyId) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLCurrencyId) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLDiscountGroupCode && y instanceof ColPLDiscountGroupCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLDiscountGroupCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLDiscountGroupCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLInternalCode && y instanceof ColPLInternalCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLInternalCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLInternalCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLOwnCode && y instanceof ColPLOwnCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLOwnCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLOwnCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLContract && y instanceof ColPLContract) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLContract) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLContract) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLValidDate && y instanceof ColPLValidDate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLValidDate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLValidDate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLChangeDate && y instanceof ColPLChangeDate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLChangeDate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLChangeDate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLUser && y instanceof ColPLUser) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLUser) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLUser) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLEanCode && y instanceof ColPLEanCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLEanCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLEanCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLTaxRate && y instanceof ColPLTaxRate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLTaxRate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLTaxRate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLIndex && y instanceof ColPLIndex) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLIndex) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLIndex) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLVendor && y instanceof ColPLVendor) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLVendor) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLVendor) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLVendorCode && y instanceof ColPLVendorCode) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLVendorCode) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLVendorCode) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLVendorUnit && y instanceof ColPLVendorUnit) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ColPLVendorUnit) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ColPLVendorUnit) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ColPLVendorBatchSize && y instanceof ColPLVendorBatchSize) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 337, column 1 - line 337, column 44): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPLColumn;
    }
};
var deleteCheckedResourcesBtn = TofuHooks.mkHookComponent("DeleteCheckedResourcesBtn")(function (props) {
    return function __do() {
        var v = TofuHooks.useState(false)();
        var confirmDeleteResourceMessage = (function () {
            if (props.countOfCheckedResources === 1) {
                return "Haluatko varmasti poistaa valitun panoshinnan?";
            };
            return "Haluatko varmasti poistaa valitut " + (Data_Show.show(Data_Show.showInt)(props.countOfCheckedResources) + " panoshintaa?");
        })();
        var modalBody = TacoModal.modalBody({
            contents: [ React_Basic_DOM.text(confirmDeleteResourceMessage) ]
        });
        var closeDeleteCheckedResourcesModal = v.value1(function (v1) {
            return false;
        });
        var modalActions = TacoModal.modalActions({
            contents: [ TacoButton.component()()({
                onClick: new Data_Maybe.Just(closeDeleteCheckedResourcesModal),
                text: "Peruuta",
                testId: "cancel-delete-checked-resources-button"
            }), TacoButton.component()()({
                text: "Poista",
                color: TacoConstants.SecondaryRed.value,
                icon: new Data_Maybe.Just(TacoIcon_Icons_Types.IconDelete24Px.value),
                onClick: new Data_Maybe.Just(function __do() {
                    props.onDeleteResources();
                    return closeDeleteCheckedResourcesModal();
                }),
                testId: "submit-delete-checked-resources-button"
            }) ]
        });
        var deleteCheckedResourcesModal = (function () {
            if (!v.value0) {
                return React_Basic.empty;
            };
            if (v.value0) {
                return TacoModal.component()()({
                    isActive: true,
                    onClose: closeDeleteCheckedResourcesModal,
                    heading: "Poista valitut panoshinnat",
                    contents: [ modalBody, modalActions ]
                });
            };
            throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 191, column 35 - line 201, column 10): " + [ v.value0.constructor.name ]);
        })();
        var button = TacoButton.component()()({
            text: "Poista valitut panoshinnat",
            icon: new Data_Maybe.Just(TacoIcon_Icons_Types.IconDelete24Px.value),
            onClick: Data_Maybe.Just.create(v.value1(function (v1) {
                return true;
            })),
            buttonStyle: TacoButton_Types.Filled.value,
            size: TacoConstants.L.value,
            testId: "delete-checked-resources-button"
        });
        return React_Basic_DOM_Generated.span_([ deleteCheckedResourcesModal, button ]);
    };
});
var allPLColumns = [ ColPLCheckbox.value, ColPLPriceListId.value, ColPLCostClassCode.value, ColPLResourceClassificationGroup.value, ColPLSortingNumber.value, ColPLName.value, ColPLUnit.value, ColPLPrice.value, ColPLDiscountPercentage.value, ColPLPriceWithDiscount.value, ColPLCurrencyId.value, ColPLDiscountGroupCode.value, ColPLInternalCode.value, ColPLOwnCode.value, ColPLContract.value, ColPLValidDate.value, ColPLChangeDate.value, ColPLUser.value, ColPLEanCode.value, ColPLTaxRate.value, ColPLIndex.value, ColPLVendor.value, ColPLVendorCode.value, ColPLVendorUnit.value, ColPLVendorBatchSize.value ];
var mkPLRow = function (props) {
    return function (v) {
        return function (r) {
            return {
                rowData: r,
                rowKey: Data_Show.show(Data_Show.showInt)(r.res.orgResourcePriceId),
                onClick: function (v1) {
                    if (props.isPanel) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                    };
                    if (!props.isPanel) {
                        return props.setSelectedResourcePrice(function (v2) {
                            return new Data_Maybe.Just(r.res);
                        });
                    };
                    throw new Error("Failed pattern match at ResourcePriceListView.PriceListTable (line 247, column 20 - line 249, column 63): " + [ props.isPanel.constructor.name ]);
                },
                className: "_PriceListRow",
                foldingElement: Data_Maybe.Nothing.value,
                columns: Data_Functor.map(Data_Functor.functorArray)(mkPlColumn(props))(Data_Array.filter(function (c) {
                    return Data_Array.elem(eqPLColumn)(c)(props.visibleColumns);
                })(allPLColumns))
            };
        };
    };
};
var addCheckedResourcesToComponentBtn = function (onAddResources) {
    return TacoButton.component()()({
        text: "Lis\xe4\xe4 valitulle suoritteelle",
        buttonStyle: TacoButton_Types.Filled.value,
        size: TacoConstants.L.value,
        icon: new Data_Maybe.Just(TacoIcon_Icons_Types.IconCopyToProjectV1.value),
        onClick: new Data_Maybe.Just(onAddResources)
    });
};
var _tableOptimized = TacoTable.tableOptimized(getNamePLSortProperty)(eqPLSortProperty)(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "socialExpensePercentagesByCostClass";
    }
})(Data_Map_Internal.eqMap(Types_Newtypes.eqCostClassCode)(Types_Unit.eqSocialExpensePercentage)))()({
    reflectSymbol: function () {
        return "showSocialExpensesInCosts";
    }
})(Data_Eq.eqBoolean))()({
    reflectSymbol: function () {
        return "res";
    }
})(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
    reflectSymbol: function () {
        return "vendor";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "validDate";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "user";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "unit";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "taxRate";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(Data_Eq.eqNumber))()({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.eqOrgEstimationResourceId))()({
    reflectSymbol: function () {
        return "price";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
    reflectSymbol: function () {
        return "ownCode";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(Data_Eq.eqInt))()({
    reflectSymbol: function () {
        return "name";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "index";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqNumber)))()({
    reflectSymbol: function () {
        return "eanCode";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(Data_Eq.eqNumber))()({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "currencyId";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Data_Nullable.eqNullable(Types_Newtypes.eqCostClassCode)))()({
    reflectSymbol: function () {
        return "contract";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "changeDate";
    }
})(Data_Nullable.eqNullable(Data_Eq.eqString)))))()({
    reflectSymbol: function () {
        return "checked";
    }
})(Data_Eq.eqBoolean)));
var priceListTable = TofuHooks.mkHookComponent("ResourcePriceListTable")(function (props) {
    var table = _tableOptimized({
        rows: props.priceListRows,
        columns: Data_Functor.map(Data_Functor.functorArray)(mkPlColumn(props))(props.visibleColumns),
        mkRow: mkPLRow(props),
        sortProperty: props.sortingCriteria.value1,
        sortingOrder: props.sortingCriteria.value0,
        rowHeight: props.rowHeight,
        onSort: props.setSortingCriteria,
        containerRef: props.containerRef,
        showHeader: true,
        styleSet: styleSet,
        initialScrollRow: Data_Maybe.Nothing.value,
        onResize: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        },
        columnSizeOffsets: Data_Maybe.Nothing.value
    });
    var replaceSelectedResourceFromPricelistBtn$prime = (function () {
        var v = Data_Array.fromFoldable(Data_Set.foldableSet)(props.checkedResources);
        var v1 = Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(function (v2) {
            return v2.selectedEditViewResource;
        })(props.panelOptions);
        var v2 = function (v3) {
            return React_Basic.empty;
        };
        if (v1 instanceof Data_Maybe.Just) {
            var $384 = Data_Array.length(v) === 1;
            if ($384) {
                var $385 = Data_Array.head(v);
                if ($385 instanceof Data_Maybe.Just) {
                    var $386 = Data_Functor.map(Data_Maybe.functorMaybe)(getResourcePriceById(props.priceListRows))(Data_Array.head(v));
                    if ($386 instanceof Data_Maybe.Just && $386.value0 instanceof Data_Maybe.Just) {
                        return replaceSelectedResourceFromPricelistBtn(props.replaceSelectedResourceFromPricelist($386.value0.value0));
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return v2(true);
        };
        return v2(true);
    })();
    return Control_Applicative.pure(Effect.applicativeEffect)(CostEstimationTableWrapper.component({
        colorSet: TacoConstants.resourcePriceListColors,
        children: [ table ],
        floatingActionButtons: React_Basic.fragment([ Data_Monoid.guard(React_Basic.monoidJSX)(!props.isPanel && Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Set.isEmpty)(props.checkedResources))(deleteCheckedResourcesBtn({
            onDeleteResources: props.deleteCheckedResources,
            countOfCheckedResources: Data_Set.size(props.checkedResources)
        })), Data_Monoid.guard(Data_Monoid.monoidFn(React_Basic.monoidJSX))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Set.isEmpty)(props.checkedResources) && Data_Maybe.isJust(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(function (v) {
            return v.selectedEditViewComponentId;
        })(props.panelOptions)))(addCheckedResourcesToComponentBtn)(props.addCheckedResourcesToComponent), Data_Monoid.guard(Data_Monoid.monoidFn(React_Basic.monoidJSX))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(Data_Set.isEmpty)(props.checkedResources) && (Data_Maybe.isJust(Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(function (v) {
            return v.selectedEditViewComponentId;
        })(props.panelOptions)) && Data_Maybe.fromMaybe(0)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Set.size)(Data_Functor.map(Data_Maybe.functorMaybe)(function (v) {
            return v.selectedEditViewResourceIds;
        })(props.panelOptions))) === 1))(replaceSelectedWithCheckedResourcesBtn)(props.replaceWithCheckedResources), replaceSelectedResourceFromPricelistBtn$prime ])
    }));
});
module.exports = {
    priceListTable: priceListTable,
    getPLRowDataFromOrgResourcePriceId: getPLRowDataFromOrgResourcePriceId,
    getResourcePriceById: getResourcePriceById,
    addCheckedResourcesToComponentBtn: addCheckedResourcesToComponentBtn,
    replaceSelectedResourceFromPricelistBtn: replaceSelectedResourceFromPricelistBtn,
    replaceSelectedWithCheckedResourcesBtn: replaceSelectedWithCheckedResourcesBtn,
    deleteCheckedResourcesBtn: deleteCheckedResourcesBtn,
    priceWithoutDiscountValue: priceWithoutDiscountValue,
    priceWithDiscountValue: priceWithDiscountValue,
    mkPLRow: mkPLRow,
    ByPLPriceListId: ByPLPriceListId,
    ByPLCostClassCode: ByPLCostClassCode,
    ByPLResourceClassificationGroup: ByPLResourceClassificationGroup,
    ByPLSortingNumber: ByPLSortingNumber,
    ByPLName: ByPLName,
    ByPLUnit: ByPLUnit,
    ByPLPrice: ByPLPrice,
    ByPLDiscountPercentage: ByPLDiscountPercentage,
    ByPLPriceWithDiscount: ByPLPriceWithDiscount,
    ByPLCurrencyId: ByPLCurrencyId,
    ByPLDiscountGroupCode: ByPLDiscountGroupCode,
    ByPLInternalCode: ByPLInternalCode,
    ByPLOwnCode: ByPLOwnCode,
    ByPLContract: ByPLContract,
    ByPLUser: ByPLUser,
    ByPLEanCode: ByPLEanCode,
    ByPLTaxRate: ByPLTaxRate,
    ByPLIndex: ByPLIndex,
    ByPLVendor: ByPLVendor,
    ByPLVendorCode: ByPLVendorCode,
    ByPLVendorUnit: ByPLVendorUnit,
    ByPLVendorBatchSize: ByPLVendorBatchSize,
    getPLSortingValue: getPLSortingValue,
    ColPLCheckbox: ColPLCheckbox,
    ColPLPriceListId: ColPLPriceListId,
    ColPLCostClassCode: ColPLCostClassCode,
    ColPLResourceClassificationGroup: ColPLResourceClassificationGroup,
    ColPLSortingNumber: ColPLSortingNumber,
    ColPLName: ColPLName,
    ColPLUnit: ColPLUnit,
    ColPLPrice: ColPLPrice,
    ColPLDiscountPercentage: ColPLDiscountPercentage,
    ColPLPriceWithDiscount: ColPLPriceWithDiscount,
    ColPLCurrencyId: ColPLCurrencyId,
    ColPLDiscountGroupCode: ColPLDiscountGroupCode,
    ColPLInternalCode: ColPLInternalCode,
    ColPLOwnCode: ColPLOwnCode,
    ColPLContract: ColPLContract,
    ColPLValidDate: ColPLValidDate,
    ColPLChangeDate: ColPLChangeDate,
    ColPLUser: ColPLUser,
    ColPLEanCode: ColPLEanCode,
    ColPLTaxRate: ColPLTaxRate,
    ColPLIndex: ColPLIndex,
    ColPLVendor: ColPLVendor,
    ColPLVendorCode: ColPLVendorCode,
    ColPLVendorUnit: ColPLVendorUnit,
    ColPLVendorBatchSize: ColPLVendorBatchSize,
    getPLColumnLabelText: getPLColumnLabelText,
    allPLColumns: allPLColumns,
    mkPlColumn: mkPlColumn,
    "_tableOptimized": _tableOptimized,
    styleSet: styleSet,
    eqPLSortProperty: eqPLSortProperty,
    ordPLSortProperty: ordPLSortProperty,
    getNamePLSortProperty: getNamePLSortProperty,
    eqPLColumn: eqPLColumn,
    ordPLColumn: ordPLColumn,
    genericPLColumn: genericPLColumn,
    tofuJSONPLColumn: tofuJSONPLColumn
};
